import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../index';

interface MethodFormState {
  /** true on method routes: /deposit, /deposit/:id, /withdrawal, /withdrawal/:id */
  isOnMethodRoute: boolean;
  /** true only on form pages: /deposit/:id, /withdrawal/:id */
  isOnFormPage: boolean;
}

const initialState: MethodFormState = {
  isOnMethodRoute: false,
  isOnFormPage: false,
};

const methodFormSlice = createSlice({
  name: 'methodForm',
  initialState,
  reducers: {
    setOnMethodRoute: (state, action: PayloadAction<boolean>) => {
      state.isOnMethodRoute = action.payload;
    },
    setOnFormPage: (state, action: PayloadAction<boolean>) => {
      state.isOnFormPage = action.payload;
    },
  },
});

export const { setOnMethodRoute, setOnFormPage } = methodFormSlice.actions;

export default methodFormSlice.reducer;

export const isOnMethodRouteSelector = (state: RootState) => state.methodForm.isOnMethodRoute;
export const isOnFormPageSelector = (state: RootState) => state.methodForm.isOnFormPage;
